import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import ApiRequest from "../../helper/ApiRequest";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const calculatorEditEndpoint = ApiEndpoints.calculator.calculatorEdit;
const calculatorUpdateEndPoint = ApiEndpoints.calculator.calculatorUpdate;

export default function EditCalculator() {
    const { roicalculator_id } = useParams();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        annual_software_cost: "",
        root_opt: "",
        root_opt_fleet_efficiency: "",
        root_opt_driver: "",
        root_opt_fuel: "",
        fuel_cost_per_litre: "",
        annual_days: "",
        working_hours_per_day: "",
    });


    // ✅ Fetch existing data
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await ApiRequest("GET", `${calculatorEditEndpoint}${roicalculator_id}`);
                const result = response.roi_calculator_data;
                setFormData({
                    annual_software_cost:result.annual_software_cost||"",
                    root_opt: result.root_opt || "",
                    root_opt_fleet_efficiency: result.root_opt_fleet_efficiency || "",
                    root_opt_driver: result.root_opt_driver || "",
                    root_opt_fuel: result.root_opt_fuel || "",
                    fuel_cost_per_litre: result.fuel_cost_per_litre || "",
                    annual_days: result.annual_days || "",
                    working_hours_per_day: result.working_hours_per_day || "",

                });
            } catch (error) {
                console.log("Fetch Error:", error);
            }
        };
        if (roicalculator_id) fetchData();
    }, [roicalculator_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ✅ Submit update
    const handleSubmit = async (e) => {
        e.preventDefault();
        const {
            annual_software_cost,
            root_opt,
            root_opt_fleet_efficiency,
            root_opt_driver,
            root_opt_fuel,
            fuel_cost_per_litre,
            annual_days,
            working_hours_per_day,
        } = formData;
        if (
            !annual_software_cost||
            !root_opt ||
            !root_opt_fleet_efficiency ||
            !root_opt_driver ||
            !root_opt_fuel ||
            !fuel_cost_per_litre ||
            !annual_days ||
            !working_hours_per_day
        ) {
            toast.error("All fields are required");
            return;
        }
        const payload = {
            roicalculator_id,
            ...formData,
        };

        try {
            const response = await ApiRequest(
                "POST", calculatorUpdateEndPoint, payload);
            toast.success(response.message || "Updated Successfully");
            navigate("/calculator");
        } catch (error) {
            console.log("Update Error:", error);
            toast.error("Something went wrong");
        }
    };
    return (
        <>
            <AdminHeader pagename="Edit Calculator" />
            <div className="add-content-page">
                <form id="newsAdd" onSubmit={handleSubmit}>
                    <div className="add-content-wrap">
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label> Software Cost ( Monthly Per Vehicle In $)<small>*</small></label>
                                    </div>
                                    <input name="annual_software_cost" value={formData.annual_software_cost} onChange={handleChange} type="text" className="form-control" placeholder="Enter Software Cost Ex. 15" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Root Optimization Saving (%)<small>*</small></label>
                                    </div>
                                    <input name="root_opt" value={formData.root_opt} onChange={handleChange} className="form-control" placeholder="Ex. 20"/>
                                </div>
                            </div>
                            {/* Fleet Efficiency */}
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Fleet Efficiency Root Optimization Saving (%)<small>*</small></label>
                                    </div>
                                    <input name="root_opt_fleet_efficiency" value={formData.root_opt_fleet_efficiency} onChange={handleChange} className="form-control" placeholder="Ex. 20"/>
                                </div>
                            </div>
                            {/* Driver */}
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Driver Root Optimization Saving (%)<small>*</small></label>
                                    </div>
                                    <input name="root_opt_driver" value={formData.root_opt_driver} onChange={handleChange} className="form-control" placeholder="Ex. 22"/>
                                </div>
                            </div>
                            {/* Fuel */}
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Fuel Root Optimization Saving (%)<small>*</small></label>
                                    </div>
                                    <input name="root_opt_fuel" value={formData.root_opt_fuel} onChange={handleChange} className="form-control" placeholder="Ex. 15"/>
                                </div>
                            </div>
                            {/* Fuel Cost */}
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Fuel Cost Per Litre ($)<small>*</small></label>
                                    </div>
                                    <input name="fuel_cost_per_litre" value={formData.fuel_cost_per_litre} onChange={handleChange} className="form-control" placeholder="Ex. 0.3"/>
                                </div>
                            </div>
                            {/* Annual Days */}
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Working Days Per Year <small>*</small></label>
                                    </div>
                                    <input name="annual_days" value={formData.annual_days} onChange={handleChange} className="form-control" placeholder="Ex. 300"/>
                                </div>
                            </div>
                            {/* Working Hours */}
                            <div className="col-lg-4">
                                <div className="add-page-inputs">
                                    <div className="label-wrap-add">
                                        <label>Working Hours Per Day <small>*</small></label>
                                    </div>
                                    <input name="working_hours_per_day" value={formData.working_hours_per_day} onChange={handleChange} className="form-control" placeholder="Ex. 8"/>
                                </div>
                            </div>

                        </div>
                    </div>
                </form>

                <button type="submit" form="newsAdd" className="default-btn">
                    Update <span></span>
                </button>
            </div>
        </>
    );
}